<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let value = 1;
    export let minValue = 0;
    export let maxValue = 0;

    const dispatch = createEventDispatcher();

    const plusValue = () => {
        if (maxValue > 0) {
            if (value + 1 > maxValue) {
                return;
            }
        }
        value++;
        dispatch('change');
    }

    const minusValue = () => {
        if (value > minValue) {
            value--;
            dispatch('change');
        }
    }

    value = ~~value;
    maxValue = ~~maxValue;

    const onChange = (event) => {
        if (value == '') {
            value = 0;
        }
    }
</script>

<div class="input-group number-spinner">
    <button class="btn btn-default" on:click="{ minusValue }">-</button>
    <input type="text" class="form-control px-0 text-center" bind:value="{ value }"
    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
           on:change={ onChange }
    >
    <button class="btn btn-default" on:click="{ plusValue }">+</button>
</div>

<style>
    .number-spinner .btn {
        width: 32px;
        padding-left: 0;
        padding-right: 0;
    }
</style>